import React, {Component} from 'react';
import PropTypes from "prop-types";

class BoldText extends Component {

  render() {
    const { text, boldEndCharacters } = this.props;

    return (
      <span>
        {text.substring(0, text.length-boldEndCharacters)}
        <strong>{text.substring(text.length-boldEndCharacters, text.length)}</strong>
      </span>
    );
  }
}

BoldText.propTypes ={
  text: PropTypes.string,
  boldEndCharacters: PropTypes.number
};

export default BoldText;
